import type { FunctionComponent, SVGProps } from 'react';

export type EuropeIconProps = SVGProps<SVGSVGElement> & {
    readonly className?: string;
    readonly fill?: string;
    readonly height?: number | string;
    readonly width?: number | string;
};

export const EuropeIcon: FunctionComponent<EuropeIconProps> = ({
    className = '',
    height = 16,
    width = 16,
    ...props
}) => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg
        className={className}
        fill="none"
        height={height}
        viewBox="0 0 24 24"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {Array.from({ length: 12 }, (_, i) => {
            const a = (i * 30 - 90) * (Math.PI / 180);
            const cx = 12 + 9 * Math.cos(a);
            const cy = 12 + 9 * Math.sin(a);

            // biome-ignore lint/suspicious/noArrayIndexKey: suppressed due to migration
            return <circle key={i} cx={cx} cy={cy} fill="currentColor" r={1.5} />;
        })}
    </svg>
);
